@if (changePasswordForm) {
  <form class="form theme-form" [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
    <div [ngClass]="{ 'modal-body': isModal }">
      <div class="row g-2">
        <div class="form-group col-md-6">
          <label for="password" class="form-label">
            {{ 'players.player.password' | translate }}
            <span class="text-danger">*</span>
          </label>
          <div class="position-relative">
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              formControlName="password"
              class="form-control"
              placeholder="********" />
            <i
              class="fa password-icon"
              [ngClass]="showPassword ? 'fa-eye' : 'fa-eye-slash'"
              (click)="togglePasswordVisibility(CHANGE_PASSWORD_CONSTANTS.PASSWORD_FIELD)"></i>
          </div>
          @if (
            changePasswordForm.get(CHANGE_PASSWORD_CONSTANTS.PASSWORD_FIELD)?.invalid &&
            changePasswordForm.get(CHANGE_PASSWORD_CONSTANTS.PASSWORD_FIELD)?.touched
          ) {
            <div class="text-danger">
              @if (
                changePasswordForm.get(CHANGE_PASSWORD_CONSTANTS.PASSWORD_FIELD)?.errors?.[
                  'required'
                ]
              ) {
                <small>
                  {{ 'players.player.passwordRequired' | translate }}
                </small>
              }
              @if (
                changePasswordForm.get(CHANGE_PASSWORD_CONSTANTS.PASSWORD_FIELD)?.errors?.[
                  'minlength'
                ]
              ) {
                <small>
                  {{ 'players.player.passwordMinLength' | translate }}
                </small>
              }
              @if (
                changePasswordForm.get(CHANGE_PASSWORD_CONSTANTS.PASSWORD_FIELD)?.errors?.[
                  'noSpacesAllowed'
                ]
              ) {
                <small>
                  {{ 'players.player.passwordNoSpaces' | translate }}
                </small>
              }
            </div>
          }
        </div>

        <div class="form-group col-md-6">
          <label for="confirmPassword" class="form-label">
            {{ 'players.player.confirmPassword' | translate }}
            <span class="text-danger">*</span>
          </label>
          <div class="position-relative">
            <input
              [type]="showConfirmPassword ? 'text' : 'password'"
              id="confirmPassword"
              formControlName="confirmPassword"
              class="form-control"
              placeholder="********" />
            <i
              class="fa password-icon"
              [ngClass]="showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'"
              (click)="
                togglePasswordVisibility(CHANGE_PASSWORD_CONSTANTS.CONFIRM_PASSWORD_FIELD)
              "></i>
          </div>
          @if (
            changePasswordForm.errors?.['mismatch'] &&
            changePasswordForm.get(CHANGE_PASSWORD_CONSTANTS.CONFIRM_PASSWORD_FIELD)?.touched
          ) {
            <div class="text-danger">
              <small>
                {{ 'players.player.passwordMismatch' | translate }}
              </small>
            </div>
          }
        </div>
        <ng-container *appShowWithPermission="PERMITTED_VIEWS.OPTIONAL_REQUIRED_CHANGE_PASSWORD">
          <div class="col-12 mt-3">
            <div
              class="password-option d-flex align-items-center gap-3 p-3"
              [class.is-on]="changePasswordForm.get('isRequiredChangePassword')?.value"
              [class.is-disabled]="changePasswordForm.disabled">
              <span
                class="password-option-icon d-flex align-items-center justify-content-center flex-shrink-0">
                <i class="fa fa-key"></i>
              </span>
              <label for="isRequiredChangePassword" class="d-flex flex-column flex-grow-1 mb-0">
                <span class="fw-semibold">
                  {{ 'players.activePlayer.requirePasswordChange' | translate }}
                </span>
                <span class="password-option-help small">
                  {{ 'players.activePlayer.requirePasswordChangeHelp' | translate }}
                </span>
              </label>
              <div class="d-flex switch-md icon-state flex-shrink-0">
                <label class="switch m-0">
                  <input
                    type="checkbox"
                    id="isRequiredChangePassword"
                    formControlName="isRequiredChangePassword" />
                  <div class="switch-state"></div>
                </label>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="modal-footer" [ngClass]="{ 'd-none': !isModal }">
      <button type="button" class="btn btn-danger" (click)="closeModal()">
        {{ 'btn.cancel' | translate }}
      </button>
      <button type="submit" class="btn btn-secondary" [disabled]="changePasswordForm.invalid">
        {{ 'players.activePlayer.changePassword' | translate }}
      </button>
    </div>
  </form>
}
